import { useEffect } from 'react';
import { useApp, useTick } from '@pixi/react';
import Dungeon from './CanvaElements/Dungeon';
import { HubScene } from './CanvaElements/Hub/HubScene';
import { useGameStore } from '../store/gameSlice';
import { useGameInput } from '../hooks/useGameInput';
import { useWorldFrozen } from '../hooks/useWorldFrozen';
import { useFloorTransitionStore } from '../store/floorTransitionSlice';
import { attachRendererStats } from '../utils/renderer-stats';
import { usePerfStatsStore } from '../store/perfStatsSlice';

const Game = () => {
  const app = useApp();
  const gameplay = useGameStore((s) => s.gameplay);
  const frozen = useWorldFrozen();
  const setCurrentDelta = useGameStore((s) => s.setCurrentDelta);
  const transitioning = useFloorTransitionStore.getState().active;

  useEffect(() => {
    (globalThis as any).__PIXI_DEVTOOLS__ = app;
  }, [app]);

  useEffect(() => {
    const { sample, detach } = attachRendererStats(app);
    const id = window.setInterval(() => {
      usePerfStatsStore.getState().setStats(sample());
    }, 1000);
    return () => {
      window.clearInterval(id);
      detach();
      usePerfStatsStore.getState().setStats(null);
    };
  }, [app]);

  useEffect(() => {
    if (!frozen) {
      app.ticker.start();
      return undefined;
    }
    app.ticker.stop();
    let rafId = 0;
    const loop = () => {
      if (transitioning) {
        app.render();
      }
      rafId = requestAnimationFrame(loop);
    };
    rafId = requestAnimationFrame(loop);
    return () => cancelAnimationFrame(rafId);
  }, [frozen, app, transitioning]);

  // Must keep running even while paused (handles PAUSE/CANCEL + endFrame).
  useGameInput();

  useTick((delta) => {
    setCurrentDelta(delta);
  });

  const renderGameplay = () => {
    switch (gameplay) {
      case 'dungeon':
        return <Dungeon />;
      case 'hub':
        return <HubScene />;
      case 'main-menu':
      default:
        return null;
    }
  };

  return <>{renderGameplay()}</>;
};

export default Game;
